import React from 'react';

import { Skeleton, Table, TableBody, TableCell, TableRow } from '@mui/material';

type SkeletonTableProps = {
  rowCount: number;
  cellCount: number;
  id: string;
};

const SkeletonTable = ({ id, cellCount, rowCount }: SkeletonTableProps) => {
  return (
    <Table size="small" aria-label="Partners table" id="partners-table">
      <TableBody>
        {Array.from({ length: rowCount }).map((_, i) => (
          <TableRow id={`${id}-row-${i}`} data-testid={id} key={i}>
            {Array.from({ length: cellCount }).map((_, iCell) => (
              <TableCell id={`${id}-cell-${iCell}`} key={iCell}>
                <Skeleton animation="wave" key={iCell} />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default SkeletonTable;
